import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ImageLoad from 'components/ImageLoad';
import Link from 'components/Link';
import TagManagerService from 'services/TagManager';
import style from './style.scss'; //NOSONAR

const creative = 'Banner Secundario Grid'

const SingleImage = (props) => {
    const singleImage = props.item;
    const active = singleImage ? singleImage.active : '';

    const [gtmData, setGtmData] = useState(null)

    const imageResponsive = {
        768: (singleImage && singleImage.imagen_mobile) ? singleImage.imagen_mobile : '',
        1440: (singleImage && singleImage.image_desktop) ? singleImage.image_desktop : ''
    };

    const promotionClick = () => {
        singleImage.title = singleImage.title ? singleImage.title : singleImage.id;
        TagManagerService.promotionsClick(singleImage, 'slot' + singleImage.bannerPosition , creative);
    }

    useEffect(() => {
        setGtmData({
            id: singleImage.id,
            name: singleImage.title,
            creative: creative,
            position: singleImage.bannerPosition || singleImage.position,
            type: 'secondaryGridBanner',
        })
    }, [singleImage])

    return (
        <div className="single-image">
            {(active === true ) && 
                <Link to={singleImage.url} onClick={() => promotionClick()}>
                    <ImageLoad
                        srcSet={imageResponsive}
                        src={singleImage.image_desktop}
                        alt={singleImage.image_desktop}
                        gtmData={gtmData}
                    />
                </Link>
            }
        </div>
    )
}

SingleImage.propTypes = {
    item: PropTypes.object,
    active: PropTypes.bool
};

export default SingleImage;
